import { useEffect, useState } from 'react';
import { fetchPublicListingBrand } from '../../util/api';

export const isShopNewListing = listing => {
  const data = listing?.attributes?.publicData || {};
  return (
    data.listingType === 'affiliate-products' ||
    data.isShopNew === true ||
    data.isAffiliate === true
  );
};

export default function useShopNewBrand(listing) {
  const [result, setResult] = useState(null);
  const id = listing?.id?.uuid;
  const brandId = listing?.attributes?.publicData?.affiliateBrandId;
  const shouldFetch = isShopNewListing(listing) && !!brandId && !!id;
  useEffect(() => {
    let active = true;
    setResult(null);
    if (shouldFetch) {
      fetchPublicListingBrand(id).then(
        brand => active && setResult({ id, brandId, brand }),
        () => active && setResult(null)
      );
    }
    return () => {
      active = false;
    };
  }, [id, brandId, shouldFetch]);
  // Missing listing IDs must not match an empty result while the page is loading.
  if (!shouldFetch || !result) return null;
  return result.id === id && result.brandId === brandId ? result.brand : null;
}
